// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fx-z","smallCardRow":"gx-z","largeCardRow":"hx-z","productSearchRow":"ix-z","curatedRow":"jx-z"};